module.exports = {
	WHOLE_CLASS: 'w',
	SPECIFIC_STUDENTS: 's'
};
